import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Dialog, DialogTitle, DialogContent, TextField, DialogActions, Button, MenuItem, CircularProgress } from '@material-ui/core';
import categoryService from '../../api/categoryService';
import { cleanCategory } from '../../redux/actions/categoryActions';
import ImageSelect from '../../shared/components/ImageSelect';

class CategoryFormModal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            name: '',
            description: '',
            idMacrocategory: '',
            icon: null,
            isSaving: false
        }

        this.selectMacrocategory = this.selectMacrocategory.bind(this);
        this.handleNameChange = this.handleNameChange.bind(this);
        this.handleDescriptionChange = this.handleDescriptionChange.bind(this);
        this.handleIconChange = this.handleIconChange.bind(this);
        this.addNewCategory = this.addNewCategory.bind(this);
        this.updateCategory = this.updateCategory.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.setCategoryDetails = this.setCategoryDetails.bind(this);
    }

    setCategoryDetails() {
        if (this.props.selectedCategory) {
            const { id, name, description, iconPath: icon, idMacrocategory } = this.props.selectedCategory;
            this.setState({
                id,
                name,
                icon,
                description,
                idMacrocategory: idMacrocategory || ''
            });
        } else {
            this.setState({
                id: null,
                name: '',
                icon: '',
                description: '',
                idMacrocategory: ''
            });
        }

    }

    selectMacrocategory(evt) {
        this.setState({
            idMacrocategory: evt.target.value
        });
    }

    handleNameChange(evt) {
        this.setState({
            name: evt.target.value
        });
    }

    handleDescriptionChange(evt) {
        this.setState({
            description: evt.target.value
        });
    }

    handleIconChange(evt) {
        if (evt && evt.currentTarget && evt.currentTarget.files[0]) {
            this.setState({
                icon: evt.currentTarget.files[0]
            });
        } else {
            this.setState({
                icon: null
            });
        }
    }

    addNewCategory() {
        this.setState({
            isSaving: true
        });
        const { name, description, icon, idMacrocategory } = this.state;

        const isSubcategory = Boolean(this.state.idMacrocategory);

        categoryService.addCategory(name, description, !isSubcategory ? icon : null, idMacrocategory)
            .then(() => {
                this.props.hideModal();
                this.setState({
                    isSaving: false
                });
            });
    }

    updateCategory() {
        this.setState({
            isSaving: true
        });
        const { id, name, description, icon, idMacrocategory } = this.state;
        const isSubcategory = Boolean(this.state.idMacrocategory);

        categoryService.updateCategory(id, name, description, !isSubcategory ? icon : null, idMacrocategory)
            .then(() => {
                this.props.hideModal();
                this.setState({
                    isSaving: false
                });
            });
    }

    closeModal() {
        this.props.cleanCategory();
        this.props.hideModal();
    }

    render() {
        const { showModal, categories } = this.props;
        const { id, name, description, idMacrocategory, icon } = this.state;
        const isEditing = Boolean(id);
        const isSubcategory = Boolean(this.state.idMacrocategory);

        let img = null;

        if (typeof icon === "string") {
            img = icon;
        } else if (icon != null) {
            img = URL.createObjectURL(icon);
        }

        return (
            <Dialog onRendered={() => {
                this.setCategoryDetails();
            }} open={showModal} onClose={this.closeModal} aria-labelledby="form-dialog-title">
                <DialogTitle id="form-dialog-title">{isEditing ? `Edit ${isSubcategory ? "subcategory" : "category"} details` : `Add a new ${isSubcategory ? "Subcategory" : "Category"}`}</DialogTitle>
                <DialogContent>
                    {
                        !isSubcategory ?
                            <ImageSelect style={{ width: '100%' }} image={img} selectText="Select a icon" onChangeImage={(evt) => this.handleIconChange(evt)} onCleanImage={(evt) => this.handleIconChange(null)} />
                            :
                            null
                    }
                    <TextField
                        autoFocus
                        variant="outlined"
                        margin="normal"
                        id="name"
                        label="Category name"
                        type="text"
                        onChange={this.handleNameChange}
                        value={name}
                        fullWidth
                    />
                    <TextField
                        margin="normal"
                        id="name"
                        variant="outlined"
                        label="Category description"
                        type="text"
                        onChange={this.handleDescriptionChange}
                        value={description}
                        fullWidth
                    />
                    {
                        !isEditing ?
                            <TextField
                                select
                                label="Macrocategory"
                                value={idMacrocategory}
                                onChange={this.selectMacrocategory}
                                style={{ width: '100%' }}
                                SelectProps={{
                                    MenuProps: {
                                        style: { width: '100%' }
                                    },
                                }}
                                helperText="Choose one if you want a subcategory."
                                margin="normal"
                                variant="outlined"
                            >
                                <MenuItem value={""}>Macrocategory...</MenuItem>
                                {
                                    categories.map((cat) => {
                                        if (cat.name !== name) {
                                            return (<MenuItem key={cat.id} value={cat.id}>{cat.name}</MenuItem>);
                                        }
                                        return null;
                                    })
                                }
                            </TextField>
                            :
                            null
                    }
                </DialogContent>
                <DialogActions>
                    <Button onClick={this.closeModal} color="primary">Back</Button>
                    <Button onClick={isEditing ? this.updateCategory : this.addNewCategory} color="primary" disabled={this.state.isSaving}>
                        {isEditing ? "Save" : "Add"}
                        {this.state.isSaving && <CircularProgress size={24} style={{ marginLeft: 15 }} />}
                    </Button>
                </DialogActions>
            </Dialog>
        );
    }
}

const mapStateToProps = store => ({
    categories: store.categoryState.categories,
    selectedCategory: store.categoryState.selectedCategory
});

const mapDispatchToProps = dispatch => (
    bindActionCreators({ cleanCategory }, dispatch)
);

export default connect(mapStateToProps, mapDispatchToProps)(CategoryFormModal);